import RuleConfig from '../../model/ruleConfig';
import { MissionRuleConfig } from './missionRuleConfig';
export default function getRuleConfig(type: string): RuleConfig {
    if (type === "mission") {
        let config: MissionRuleConfig = {
            memberScope: "All",
            memberTags: [],
            cumulativeWithOtherDiscount: false,
            discounts: [],
            missionType: "",
            value: 0,
            coupons: []
        };
        return config;
    }
    else {
        let config: RuleConfig = {
            memberScope: "All",
            memberTags: [],
            cumulativeWithOtherDiscount: false,
            discounts: []
        };
        return config;
    }

}